/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConsumerLinkCalendarGet$Params {
  redirectURL?: string;
}

export function consumerLinkCalendarGet(http: HttpClient, rootUrl: string, params?: ConsumerLinkCalendarGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, consumerLinkCalendarGet.PATH, 'get');
  if (params) {
    rb.query('redirectURL', params.redirectURL, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<string>;
    })
  );
}

consumerLinkCalendarGet.PATH = '/Consumer/LinkCalendar';
